<script lang="ts">
  import classnames from "classnames"
</script>

<div class="{classnames('feature-boxes', $$props.class)}">
  <slot />
</div>

<style type="text/scss" lang="scss" scoped>
  .feature-boxes {
    @apply page-max-width;
    @apply my-6 lg:my-16;
    @apply flex flex-nowrap overflow-x-auto overflow-y-hidden;
    scroll-snap-type: x mandatory;
    scroll-snap-points-x: repeat(100%);
    scroll-snap-destination: 100% 0%;
    /* You can ommit it in iOS 13 */
    -webkit-overflow-scrolling: touch;
    scroll-padding: var(--page-margin);
    padding-left: var(--page-margin);
    margin-left: calc(var(--page-margin) * -1);
    margin-right: calc(var(--page-margin) * -1);
    /* From scrollable area to grid items */
    @apply lg:grid lg:grid-cols-3 lg:gap-0;
    @apply lg:mx-0 lg:px-0;

    &::-webkit-scrollbar {
      @apply hidden;
    }

    &::after {
      /** add space at the end */
      content: "";
      @apply block;
      @apply ml-4 md:ml-10;
      @apply lg:hidden;
    }
  }

  :global(.feature-boxes > *) {
    @apply flex-shrink-0 lg:flex-shrink;
    @apply w-[80vw] max-w-[350px];
    scroll-snap-align: start;
    @apply lg:w-full lg:max-w-none;
    @apply lg:w-full lg:min-w-full;
  }

  :global(.feature-boxes > * + *) {
    @apply ml-3.5 lg:ml-0;
  }
</style>
